module.exports = __webpack_public_path__ + "NanumBarunGothicBold.svg";